import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { OptionUI } from '@calendly/ui/components/select';
import { useBooleanState } from 'hooks/useBooleanState';
import { useIsMounted } from 'hooks/useIsMounted';
const optionCss = "o1k2y1yk";
const loaderCss = "lsv0m0x";
const ShowMore = ({
  onClick
}) => {
  const [isLoading, startLoading, stopLoading] = useBooleanState(false);
  const isMounted = useIsMounted();
  const wrappedOnClick = async () => {
    startLoading();
    await onClick();
    if (isMounted.current) stopLoading();
  };
  if (isLoading) return <Loader className={loaderCss} size="small" />;
  return <OptionUI className={optionCss} role="option" onClick={wrappedOnClick}>
      {I18n.t('publisher.title.show_more')}
    </OptionUI>;
};
export default ShowMore;

require("./show_more.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./show_more.js");